const sum = (a) => a.reduce((a2, b) => a2 + b, 0);
export function calculate(input = {
  reachableUserBase: 0,
  notificationsPerDay: 0,
  avgClickthroughRate: 0,
  conversionRate: 0,
  averageOrderValue: 0,
  operatingMargin: 0,
  churnRate: 0,
  annualCustomerValue: 0,
  effortPerCampaign: 0
}) {
  const ctrImprovement = [0.4, 0.45, 0.5];
  const ctrWithClevertap = ctrImprovement.map((x) => (1 + x) * input.avgClickthroughRate);
  const netNewDailyCtr = ctrWithClevertap.map((x) => Math.round(input.reachableUserBase * input.notificationsPerDay * (x - input.avgClickthroughRate)));
  const conversionImprovement = [0.25, 0.3, 0.35];
  const conversionWithClevertap = conversionImprovement.map((x) => (1 + x) * input.conversionRate);
  const netNewDailyConversions = conversionWithClevertap.map((x, i) => x * netNewDailyCtr[i]);
  const netMargin = input.operatingMargin.toFixed(3);
  const improvedConversionRates = netNewDailyConversions.map((x) => 365 * x * netMargin * input.averageOrderValue);
  const riskAdjustment = -0.2;
  const riskAdjustedConversionRates = improvedConversionRates.map((x) => x * (1 + riskAdjustment));
  const PRESENT_VALUE_CONVERSION = 0.8211101598;
  const conversionRate = Math.round(sum(riskAdjustedConversionRates) * PRESENT_VALUE_CONVERSION);
  const activeCustomerBase = input.reachableUserBase * 0.6;
  const churnAfterClevertap = [0.9, 0.8, 0.7].map((x) => x * input.churnRate);
  const improvedRetention = churnAfterClevertap.map((x) => Math.round(netMargin * (input.churnRate - x) * activeCustomerBase * input.annualCustomerValue));
  const riskAdjustedRetention = improvedRetention.map((x) => x * (1 + riskAdjustment));
  const PRESENT_VALUE_RETENTION = 0.8026546149;
  const customerRetention = Math.round(sum(riskAdjustedRetention) * PRESENT_VALUE_RETENTION);
  const duplicateStreams = 3;
  const dailyDuplication = input.notificationsPerDay * input.effortPerCampaign * duplicateStreams / 60;
  const AVG_HOURLY_RATE = 17.5;
  const improvedCampaignEfficiency = 365 * dailyDuplication * AVG_HOURLY_RATE;
  const efficiencyRisk = -0.05;
  const riskAdjustedCampaignEfficiency = (1 + efficiencyRisk) * improvedCampaignEfficiency;
  const PRESENT_VALUE_EFFICIENCY = 0.828950939;
  const campaignEfficiency = Math.round(3 * riskAdjustedCampaignEfficiency * PRESENT_VALUE_EFFICIENCY);
  const solutionCost = 531250;
  const solutionSavings = 0.2 * solutionCost;
  const riskAdjustedOpCost = solutionSavings * 0.9;
  const PRESENT_VALUE_OPEF = 0.8289506173;
  const costSavings = Math.round(3 * riskAdjustedOpCost * PRESENT_VALUE_OPEF);
  return {
    conversionRate,
    customerRetention,
    campaignEfficiency,
    costSavings
  };
}
